import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allReligionMapping : []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.MAP_RELIGION_NEXT_STEP: 
          return {...state,currentStep : state.currentStep + 1};
        case actionTypes.MAP_RELIGION_PREVIOUS_STEP :
          return {...state,currentStep : state.currentStep - 1};
        case actionTypes.MAP_RELIGION_UPLOAD_FILE_SUCCESS :
        return {...state, allColumns : action.val.columns, rowData : action.val.data, file: action.val.file};
        case actionTypes.MAP_RELIGION_MATCH_COLUMN_SUCCESS :
        return {...state, matchedColumn : action.val};
        case actionTypes.MAP_RELIGION_SAVE_RELIGION_MAPPING :
          return {...state, allReligionMapping : action.val};
        default:
          break;
    }
    return state;
}